import React from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { FormikTimePicker, FormikSelect, FormikInput, InputSelect } from '../../../../components';
import { delayMethod } from '../../../../services/utils';
import { debounceIndexShiftsRequest } from '../../../../requests/shifts';

const MassiveAttendanceFormReplace = props => {
  const {
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    handleModalClose,
    onHide,
    isSubmitting,
    branchOffices,
    values
  } = props;
  const dispatch = useDispatch();
  const { attendance: vAttendance } = values;
  const resultFetchData = (response, type) => {
    const result = response.data.data;
    return result.map(element => ({
      ...element,
      label: `${type ? `${element.code} - ` : ''} ${element.name}`,
      value: element.id
    }));
  };

  const fetchContractShift = (inputValue, callback) => {
    debounceIndexShiftsRequest({
      dispatch,
      params: {
        active: true,
        query: inputValue,
        sort_column: 'name',
        paginate: false
      },
      successCallback: data => {
        callback(resultFetchData(data));
      }
    });
  };

  return (
    <>
      {isSubmitting && <div className="loader">Cargando..</div>}
      <Form>
        <Modal.Body>
          <Row>
            <Col md={12} className="d-grid">
              <span>
                <b>Nueva Hora de marcacion</b>
              </span>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Field name="attendance[date]">
                {({ field }) => (
                  <FormikInput
                    {...field}
                    label="Fecha inicio de jornada"
                    touched={getIn(touched, field.name)}
                    readOnly
                  />
                )}
              </Field>
            </Col>
            <Col md={4}>
              <Field name="attendance[branchOfficeId]">
                {({ field }) => (
                  <FormikSelect
                    {...field}
                    abbr
                    label="Lugar de Prestación de Servicios"
                    options={branchOffices}
                    onChange={data => {
                      setFieldValue(field.name, data ? data.value : '');
                    }}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={4}>
              <Field name="attendance[shiftId]">
                {({ field }) => (
                  <InputSelect
                    {...field}
                    label="Turno"
                    value={undefined}
                    request={fetchContractShift}
                    onChange={data => {
                      setFieldValue(field.name, data ? data.value : '');
                    }}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
          </Row>

          <Row className="datetime">
            <Col md={3}>
              <Field name="attendance[parsedArrival]">
                {({ field }) => (
                  <FormikTimePicker
                    {...field}
                    label="Entrada"
                    showTimeSelect
                    timeIntervals={1}
                    timeCaption="Hora"
                    isClearable
                    timeFormat="p"
                    dateFormat="Pp"
                    selected={vAttendance?.arrival ? new Date(vAttendance?.arrival) : null}
                    onChange={date => {
                      setFieldValue(field.name, date ? date.toLocaleString('en-GB') : '');
                      setFieldValue(`attendance[arrival]`, date);
                    }}
                    setFieldTouched={() => setFieldTouched(field.name)}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={3}>
              <Field name="attendance[parsedArrivalBreak]">
                {({ field }) => (
                  <FormikTimePicker
                    {...field}
                    label="Entrada Colación"
                    showTimeSelect
                    timeIntervals={1}
                    isClearable
                    timeCaption="Hora"
                    timeFormat="p"
                    dateFormat="Pp"
                    selected={vAttendance?.arrivalBreakTime ? new Date(vAttendance?.arrivalBreakTime) : null}
                    onChange={date => {
                      setFieldValue(`attendance[arrivalBreakTime]`, date);
                      setFieldValue(field.name, date ? date.toLocaleString('en-GB') : '');
                    }}
                    setFieldTouched={() => setFieldTouched(field.name)}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={3}>
              <Field name="attendance[parsedDepartureBreak]">
                {({ field }) => (
                  <FormikTimePicker
                    {...field}
                    label="Salida Colación"
                    showTimeSelect
                    isClearable
                    timeIntervals={1}
                    timeCaption="Hora"
                    timeFormat="p"
                    dateFormat="Pp"
                    selected={vAttendance?.departureBreakTime ? new Date(vAttendance?.departureBreakTime) : null}
                    onChange={date => {
                      setFieldValue(`attendance[departureBreakTime]`, date);
                      setFieldValue(field.name, date ? date.toLocaleString('en-GB') : '');
                    }}
                    setFieldTouched={() => setFieldTouched(field.name)}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={3}>
              <Field name="attendance[parsedDeparture]">
                {({ field }) => (
                  <FormikTimePicker
                    {...field}
                    label="Salida"
                    showTimeSelect
                    timeIntervals={1}
                    timeCaption="Hora"
                    timeFormat="p"
                    isClearable
                    dateFormat="Pp"
                    selected={vAttendance?.departure ? new Date(vAttendance?.departure) : null}
                    onChange={date => {
                      setFieldValue(`attendance[departure]`, date);
                      setFieldValue(field.name, date ? date.toLocaleString('en-GB') : '');
                    }}
                    setFieldTouched={() => setFieldTouched(field.name)}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button className="text-center" variant="outline-info" onClick={() => delayMethod(handleModalClose)}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" onClick={onHide} disabled={isSubmitting}>
            Guardar
          </Button>
        </Modal.Footer>
      </Form>
    </>
  );
};

const setInitialValues = props => {
  const { attendances } = props;
  const employeeIds = [...new Set(attendances.map(attendance => attendance?.employee_id))];

  return {
    attendance: {
      date: attendances[0].date,
      branchOfficeId: '',
      shiftId: '',
      parsedArrival: '',
      parsedDeparture: '',
      parsedArrivalBreak: '',
      parsedDepartureBreak: '',
      arrival: '',
      departure: '',
      arrivalBreakTime: '',
      departureBreakTime: '',
      employeeIds
    }
  };
};

const validationSchema = Yup.object().shape({
  attendance: Yup.object().shape({
    branchOfficeId: Yup.string().required('Debes seleccionar un lugar de prestación de servicios')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;

  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: false
})(MassiveAttendanceFormReplace);
